<template>
  <div
    class="SearchSidebarBlock"
    data-cy-id="search-type"
  >
    <h5
      v-if="!isMobile"
      class="SearchFilter-title"
    >
      Filter By:
    </h5>
    <ul
      :class="getClass"
      class="SearchTypes"
    >
      <li class="SearchTypes-type">
        <a
          :class="[{ 'is-active': isActiveType('jobs') },'SearchTypes-link']"
          href="/search-jobs"
          @click.prevent="updateQueryShowParam('jobs')"
        >
          Jobs
        </a>
      </li>
      <li class="SearchTypes-type">
        <a
          :class="[{ 'is-active': isActiveType('reviews') }, 'SearchTypes-link']"
          href="/search-reviews"
          @click.prevent="updateQueryShowParam('reviews')"
        >
          Reviews
        </a>
      </li>
      <li class="SearchTypes-type">
        <a
          :class="[{ 'is-active': isActiveType('companies') }, 'SearchTypes-link']"
          href="/search-companies"
          @click.prevent="updateQueryShowParam('companies')"
        >
          Companies
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

export default {
  props: {
    isMobile: {
      default: false,
      type: Boolean,
    },
  },

  data() {
    return {};
  },

  computed: {
    searchShowParam: {
      get() {
        return this.$store.state.search.query.show;
      },
    },
    getClass() {
      return this.isMobile ? 'MobileView' : 'DesktopView';
    },
    ...mapGetters('search', {
      getDefaultSortOrder: 'getDefaultSortOrder',
      getDefaultUrls: 'getDefaultUrls',
    }),
  },

  // Emitted from resources/assets/vue/vanilla/search/mobile-search.js
  // this is the bridge between vanilla js and vue because of
  // Googles LCP performance penalties
  created() {
    this.$bus.$on('bus:mobile-header:navigation', this.updateQueryShowParam);
  },
  beforeDestroy() {
    this.$bus.$off('bus:mobile-header:navigation', this.updateQueryShowParam);
  },

  methods: {
    ...mapMutations('search', {
      updateQueryFilters: 'updateQueryFilters',
      resetQueryParams: 'resetQueryParams',
      setLoadingState: 'setLoadingState',
      updateSearchUrl: 'updateSearchUrl',
    }),
    updateQueryShowParam(searchScope) {
      const defaultUrls = this.getDefaultUrls;
      this.updateSearchUrl(defaultUrls[searchScope]);

      this.setLoadingState({ loadingState: true });

      this.resetQueryParams({
        query: {
          show: searchScope,
        },
      });

      // TODO: for some reason the property isnt reactive on first click.
      this.$nextTick(() => {
        this.updateSearchUrl(defaultUrls[searchScope]);

        this.updateQueryFilters({
          filterValues: searchScope,
          filterName: 'show',
        });
        this.updateQueryFilters({
          filterValues: this.getDefaultSortOrder({ searchType: searchScope }),
          filterName: 'od',
        });
      });
    },
    isActiveType(value) {
      return this.searchShowParam === value;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../scss/abstracts/abstracts";

.SearchSidebarBlock {

}

.SearchSidebarBlock-item {
  margin-bottom: 1rem;
  &:last-child {
    margin-bottom: 0;
  }
  a {
    &:before {
      content: "";
      margin-top: 2px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      background: #e2e0dc;
      border: 1px solid #e2e0dc;
      float: left;
      margin-right: 10px;
      border-radius: 20px;
    }
    color: color('grey', 'dark');
    margin-bottom: .5rem;
    &.active {
      color: color($primary-color);
      &:before {
        background: #fff;
        border: 6px solid color($primary-color);
      }
    }
  }
}

.DesktopView {
  .SearchTypes-type {
    margin-bottom: .5rem;
  }

  .SearchTypes-link {
    &:before {
      margin-top: 2px;
      width: 20px;
      height: 20px;
      border-radius: 20px;
      line-height: 20px;
      background: #e2e0dc;
      border: 1px solid #e2e0dc;
      float: left;
      content: '';
      margin-right: 10px;
    }
    &.is-active {
      &:before {
        border: 6px solid color($primary-color);
        background: #fff;
      }
    }
  }
}

.MobileView {
  &.SearchTypes {
    display: flex;
    align-items: center;
    width: 100%;
    flex-direction: row;
    margin: 0 0 .5rem 0;
    @include respond-to(sm, max-width) {
      justify-content: space-between;
    }
  }

  .SearchTypes-type {
    padding: 0;
    margin-right: 1rem;
    color: color('white');
    &:last-child {
      margin-right: 0;
    }
    a {
      font-size: 16px;
      border-bottom: 2px solid transparent;
      padding: .5rem;
      display: block;
      color: color('white');
      &.is-active {
        border-color: color('white');
      }
    }
  }
}

</style>
